module.exports = __webpack_public_path__ + "img/csorbics-bg.47120875.jpg";